import { useEffect } from 'react';

import { useRouter } from '@/hooks/useRouter';
import { PUBLIC_URL } from '@/lib/const';
import { getRegionFromLocale } from '@/lib/regions';
import { StorageHelper } from '@/lib/storage';
import { useGlobalEContext } from '@/providers/GlobalEProvider/GlobalEProviderContext';

export const useGlobalECookies = () => {
  const { locale, pathname } = useRouter();
  const { setLoadScript } = useGlobalEContext();

  useEffect(() => {
    if (!locale) return;

    const storageHelper = new StorageHelper();
    const domain = `.${new URL(PUBLIC_URL).hostname}`;
    const { country, locale: newLocale } = getRegionFromLocale(locale);

    storageHelper.setCookie(
      'GlobalE_Data',
      JSON.stringify({
        countryISO: country.code,
        currencyCode: country.currency,
        cultureCode: null,
      }),
      { domain },
    );
    storageHelper.setCookie('GlobalE_Locale', `${newLocale.locale}`, {
      domain,
    });

    // The global-e script is ready to be loaded
    setLoadScript(true);
  }, [locale, pathname]);
};
